"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetTransacSmsReport {
    static getAttributeTypeMap() {
        return GetTransacSmsReport.attributeTypeMap;
    }
}
GetTransacSmsReport.discriminator = undefined;
GetTransacSmsReport.attributeTypeMap = [
    {
        "name": "reports",
        "baseName": "reports",
        "type": "Array<GetTransacSmsReportReports>"
    }
];
exports.GetTransacSmsReport = GetTransacSmsReport;
//# sourceMappingURL=getTransacSmsReport.js.map